import {
  useVendorListLazyQuery,
  useVendorMapListLazyQuery,
  useVendorsSummaryLazyQuery,
} from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import { useEffect, useMemo } from "react"
import { useFilter } from "store/search-filter/search-filter.reducer"
export function useVendorVariables() {
  const [filter] = useFilter("vendors")
  const group = useActiveVendorGroup()
  const [{ search, page }] = useSearchFilter()
  return useMemo(
    () => ({
      query: search,
      groupName: group?.name || "*",
      first: 13,
      skip: 13 * page,
      status: filter.status?.id,
      filter: {
        distributionCenterId: filter?.distributionCenterId?.id,
        active: filter?.active?.id,
        inactive: filter?.inactive?.id,
      },
    }),
    [search, filter, page, group]
  )
}
export function useVendorList() {
  const variables = useVendorVariables()

  const [getData, response] = useVendorListLazyQuery()

  useEffect(() => {
    if (variables?.groupName) {
      getData({
        variables,
      })
    }
  }, [variables, getData])
  return response
}

export function useVendorMapList() {
  const variables = useVendorVariables()
  const [getData, response] = useVendorMapListLazyQuery()

  useEffect(() => {
    if (variables.groupName) {
      getData({
        variables: {
          ...variables,
          first: undefined,
          skip: undefined,
        },
      })
    }
  }, [variables, getData])

  return response
}

export function useVendorSummary(last: number) {
  const group = useActiveVendorGroup()
  const groupName = group?.name
  const [getData, response] = useVendorsSummaryLazyQuery()
  useEffect(() => {
    if (last && groupName) {
      getData({
        variables: {
          latestDays: last,
          filter: {
            groups: groupName,
          },
        },
      })
    }
  }, [last, getData, groupName])
  return response
}

export function useActiveVendorGroup() {
  const [filter] = useFilter("vendors")
  return filter?.group
}
